import React, { useState } from "react";
import { motion } from "framer-motion";
import { SKILLS_DATA } from "@/data/portfolio";
import { SKILLS } from "@/constants/testIds";
import SectionHeading from "@/components/molecules/SectionHeading";

export default function Skills() {
  const [active, setActive] = useState(SKILLS_DATA[0].category);
  const current = SKILLS_DATA.find((c) => c.category === active);

  return (
    <section id="skills" data-testid={SKILLS.section} className="section relative">
      <div className="container-x">
        <SectionHeading
          overline="02 — Skills"
          title="The tools I reach for daily."
          description="A curated stack of frameworks, languages and AI tools sharpened across five years of enterprise work."
        />

        <div className="flex flex-wrap gap-2 mb-10">
          {SKILLS_DATA.map((cat) => (
            <button
              key={cat.category}
              onClick={() => setActive(cat.category)}
              className={`label-mono px-4 py-2 rounded-full border transition ${
                active === cat.category
                  ? "border-[color:var(--accent)] text-[color:var(--accent)] bg-[color:var(--accent)]/5"
                  : "border-[color:var(--border)] text-[color:var(--text-muted)] hover:text-[color:var(--text)]"
              }`}
            >
              {cat.category}
            </button>
          ))}
        </div>

        <motion.div
          key={active}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[color:var(--border)] rounded-3xl overflow-hidden border border-[color:var(--border)]"
        >
          {current.items.map((s, i) => (
            <motion.div
              key={s.name}
              data-testid={SKILLS.card(s.name.toLowerCase().replace(/[^a-z0-9]/g, "-"))}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04 }}
              whileHover={{ y: -3 }}
              className="bg-[color:var(--bg)] p-6 group hover:bg-[color:var(--surface)] transition-colors"
            >
              <div className="flex items-baseline justify-between mb-3">
                <span className="font-display text-lg">{s.name}</span>
                <span className="label-mono text-[color:var(--accent)]">{s.level}%</span>
              </div>
              <div className="h-1 rounded-full bg-[color:var(--border)] overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: `${s.level}%` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, delay: 0.1 + i * 0.05, ease: [0.2, 0.8, 0.2, 1] }}
                  className="h-full bg-[color:var(--accent)]"
                />
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
